'use client';

import { useEffect, useRef, useState } from 'react';
import { Share2 } from 'lucide-react';
import { readWikiUser } from '../lib/wiki-auth';
import './share-action.css';

export default function ShareAction({ linkUrl, title, subject = '文章', className = '' }: {
  linkUrl: string;
  title: string;
  subject?: string;
  className?: string;
}) {
  const [notice, setNotice] = useState('');
  const [leaving, setLeaving] = useState(false);
  const [noticeKey, setNoticeKey] = useState(0);
  const waitTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const exitTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => {
    if (waitTimer.current) clearTimeout(waitTimer.current);
    if (exitTimer.current) clearTimeout(exitTimer.current);
  }, []);

  const showNotice = (message: string) => {
    if (waitTimer.current) clearTimeout(waitTimer.current);
    if (exitTimer.current) clearTimeout(exitTimer.current);
    setNotice(message);
    setLeaving(false);
    setNoticeKey(value => value + 1);
    waitTimer.current = setTimeout(() => {
      setLeaving(true);
      exitTimer.current = setTimeout(() => setNotice(''), 220);
    }, 2000);
  };

  const share = async () => {
    const name = readWikiUser()?.name || 'GameKee用户';
    const url = new URL(linkUrl, window.location.origin).href;
    const content = `${name}分享了文章：${title}\n${url}\n来自GameKee`;
    try {
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(content);
          showNotice('分享成功，已复制链接');
          return;
        } catch { /* Use the browser copy command below. */ }
      }
      const textarea = document.createElement('textarea');
      textarea.value = content;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      const copied = document.execCommand('copy');
      textarea.remove();
      if (!copied) throw new Error('copy failed');
      showNotice('分享成功，已复制链接');
    } catch {
      showNotice('复制失败');
    }
  };

  return <div className={`share-action ${className}`.trim()}>
    <button type="button" onClick={() => void share()} aria-label={`分享${subject}`}><Share2 aria-hidden="true" size={17} /><span>分享</span></button>
    {notice && <span key={noticeKey} className={`share-action-toast${leaving ? ' is-leaving' : ''}`} role="status">{notice}</span>}
  </div>;
}
